import HeaderCell from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/HeaderCell'
import withAlignment, {
  Alignment
} from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/Alignment'
import { VerticalAlignment } from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/Alignment/Alignment'
import {
  Column,
  ColumnType
} from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import ActivityFamilyLine from '@modules/order/components/CellTemplates/KPI/ActivityFamilyLine'
import GenericDecimalValueComponent from '@modules/order/components/CellTemplates/KPI/GenericDecimalValueComponent'
import GenericField from '@modules/order/components/CellTemplates/KPI/GenericFieldComponent'
import GenericFieldCurrencyComponent from '@modules/order/components/CellTemplates/KPI/GenericFieldCurrencyComponent'
import GenericValueComponent from '@modules/order/components/CellTemplates/KPI/GenericValueComponent'
import { KPIViewKeyMap } from '@modules/order/constants/keys'
import cloneDeep from 'lodash/cloneDeep'
import ViewSettingStore from '../../ViewSettingStore'

export enum KPITableView {
  Overview = 'Overview',
  DoorsKPI = 'DoorsKPI',
  Buy = 'Buy',
  Forecast = 'Forecast'
}

export default class KPIViewTableService extends ViewSettingStore {
  private fixedColumns = [
    {
      field: 'name',
      label: 'Activity/ Family/ Line',
      key: 'activityFamilyLine',
      allowHide: false,
      fixed: true,
      allowReordering: false,
      showBorders: true,
      hierarchyRowCellTemplate: withAlignment(
        ActivityFamilyLine,
        Alignment.LEFT,
        VerticalAlignment.CENTER
      ),
      headerCellElement: withAlignment(
        HeaderCell,
        Alignment.LEFT,
        VerticalAlignment.CENTER
      ),
      width: 300
    }
  ] as Column[]

  private getKPIColumns = quantityType => {
    return [
      {
        label: 'Actual/ Target Mix Quantity',
        allowHide: true,
        key: 'kpis.actualTargetMixQuantity',
        allowReordering: true,
        showBorders: true,
        hierarchyRowCellTemplate: GenericField,
        width: 200,
        field: `kpis.${KPIViewKeyMap[quantityType]?.actualMixQuantity}`
      },
      {
        label: 'Actual/ Target Mix Value',
        allowHide: true,
        key: 'kpis.actualTargetMixValue',
        allowReordering: true,
        showBorders: true,
        hierarchyRowCellTemplate: GenericField,
        width: 200,
        field: `kpis.${KPIViewKeyMap[quantityType]?.actualMixValue}`
      },
      {
        label: 'Quantity',
        allowHide: true,
        key: 'kpis.quantity',
        allowReordering: true,
        showBorders: true,
        hierarchyRowCellTemplate: GenericValueComponent,
        width: 150,
        field: `kpis.${KPIViewKeyMap[quantityType]?.totalQuantity}`
      },
      {
        label: 'Value',
        allowHide: true,
        key: 'kpis.value',
        allowReordering: true,
        showBorders: true,
        hierarchyRowCellTemplate: GenericFieldCurrencyComponent,
        width: 150,
        field: `kpis.${KPIViewKeyMap[quantityType]?.totalValue}`
      }
    ]
  }

  private getRetailKPIColumns = (subSection: string) => {
    //Retail KPI common columns
    const avgWeekSales = {
      label: 'Avg Week Sales',
      allowHide: true,
      key: 'kpis.aws',
      showBorders: true,
      allowReordering: true,
      hierarchyRowCellTemplate: GenericDecimalValueComponent,
      width: 150,
      field: 'kpis.aws'
    }
    const avgDepth = {
      label: 'Avg Depth',
      allowHide: true,
      key: 'kpis.averageDepth',
      showBorders: true,
      allowReordering: true,
      hierarchyRowCellTemplate: GenericDecimalValueComponent,
      width: 150,
      field: 'kpis.averageDepth'
    }
    const skuEfficiency = {
      label: 'SKU Eff',
      allowHide: true,
      key: 'kpis.skuEfficiency',
      showBorders: true,
      allowReordering: true,
      hierarchyRowCellTemplate: GenericDecimalValueComponent,
      width: 150,
      field: 'kpis.skuEfficiency'
    }
    const numberOfStores = {
      label: 'Total Stores',
      allowHide: true,
      key: 'kpis.numberOfStores',
      showBorders: true,
      allowReordering: true,
      hierarchyRowCellTemplate: GenericField,
      width: 150,
      field: 'kpis.numberOfStores'
    }
    const salesQty = {
      label: 'Sales Qty',
      allowHide: true,
      key: 'kpis.salesQty',
      showBorders: true,
      allowReordering: true,
      hierarchyRowCellTemplate: GenericDecimalValueComponent,
      width: 150,
      field: 'kpis.salesQty'
    }
    return subSection === KPITableView.Forecast
      ? ([
          avgWeekSales,
          {
            label: 'Mix Qty',
            allowHide: true,
            key: 'kpis.mixRatioByDraftQty',
            allowReordering: true,
            showBorders: true,
            hierarchyRowCellTemplate: GenericField,
            width: 150,
            field: 'kpis.mixRatioByDraftQty'
          },
          {
            label: 'Mix Value',
            allowHide: true,
            key: 'kpis.mixRatioByDraftValue',
            allowReordering: true,
            showBorders: true,
            hierarchyRowCellTemplate: GenericField,
            width: 150,
            field: 'kpis.mixRatioByDraftValue'
          },
          avgDepth,
          skuEfficiency,
          numberOfStores,
          {
            label: 'Forecast Value',
            allowHide: true,
            key: 'kpis.totalForecastValue',
            showBorders: true,
            allowReordering: true,
            hierarchyRowCellTemplate: GenericFieldCurrencyComponent,
            width: 150,
            field: 'kpis.totalForecastValue'
          },
          salesQty,
          {
            label: 'Forecast Qty',
            allowHide: true,
            key: 'kpis.totalForecastQuantity',
            showBorders: true,
            allowReordering: true,
            hierarchyRowCellTemplate: GenericField,
            width: 150,
            field: 'kpis.totalForecastQuantity'
          }
        ] as Column[])
      : ([
          numberOfStores,
          {
            label: 'Forecast Qty',
            allowHide: true,
            key: 'kpis.totalForecastQuantity',
            showBorders: true,
            allowReordering: true,
            hierarchyRowCellTemplate: GenericField,
            width: 150,
            field: 'kpis.totalForecastQuantity'
          },
          {
            label: 'Order Qty',
            allowHide: true,
            key: 'kpis.totalBuyQuantity',
            showBorders: true,
            allowReordering: true,
            hierarchyRowCellTemplate: GenericField,
            width: 150,
            field: 'kpis.totalBuyQuantity'
          },
          avgWeekSales,
          avgDepth,
          skuEfficiency,
          {
            label: 'Order Value',
            allowHide: true,
            key: 'kpis.totalBuyValue',
            showBorders: true,
            allowReordering: true,
            hierarchyRowCellTemplate: GenericFieldCurrencyComponent,
            width: 150,
            field: 'kpis.totalBuyValue'
          },
          salesQty
        ] as Column[])
  }

  getColumns(doors: any[], quantityType, isRetailClient = false, subSection = '') {
    return isRetailClient
      ? ([...this.fixedColumns, ...this.getRetailKPIColumns(subSection)] as Column[])
      : ([
          ...this.fixedColumns,
          ...(doors?.length
            ? doors.map(
                door =>
                  ({
                    label: door.name,
                    allowHide: true,
                    allowReordering: true,
                    showBorders: true,
                    type: ColumnType.Grouped,
                    field: `kpis.doorKpis.${door.id}`,
                    columns: cloneDeep(this.getKPIColumns(quantityType)).map(col => {
                      col['allowReordering'] = false
                      col['field'] = `kpis.doorKpis.${door.id}.${col.field
                        .split('.')
                        .splice(1, 1)}`
                      return col
                    })
                  } as Column)
              )
            : this.getKPIColumns(quantityType))
        ] as Column[])
  }
}
